import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { FilePlus2, History as HistoryIcon, Settings as SettingsIcon, Package, LogOut } from "lucide-react";

const nav = [
  { to: "/", label: "Nuovo Ordine", icon: FilePlus2, testid: "nav-new-order-link", end: true },
  { to: "/storico", label: "Storico", icon: HistoryIcon, testid: "nav-history-link" },
  { to: "/impostazioni", label: "Impostazioni", icon: SettingsIcon, testid: "nav-settings-link" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const current = nav.find((n) => (n.end ? location.pathname === n.to : location.pathname.startsWith(n.to)));

  return (
    <div className="min-h-screen flex bg-slate-50 dark:bg-slate-950">
      <aside className="w-64 shrink-0 border-r border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex flex-col">
        <div className="p-5 flex items-center gap-3 border-b border-slate-200 dark:border-slate-800">
          <div className="h-10 w-10 rounded-xl bg-blue-600 grid place-items-center text-white">
            <Package className="h-5 w-5" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-slate-900 dark:text-slate-100">MM Operations</div>
            <div className="text-xs text-slate-500">Integration Hub</div>
          </div>
        </div>
        <nav className="p-3 space-y-1 flex-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-blue-600 text-white shadow-sm"
                    : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
                }`
              }
            >
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200 dark:border-slate-800">
          <div className="flex items-center gap-3 px-2 py-2">
            {user?.picture ? (
              <img src={user.picture} alt="" className="h-8 w-8 rounded-full" />
            ) : (
              <div className="h-8 w-8 rounded-full bg-slate-200 dark:bg-slate-700" />
            )}
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium text-slate-900 dark:text-slate-100 truncate">{user?.name}</div>
              <div className="text-xs text-slate-500 truncate">{user?.email}</div>
            </div>
          </div>
          <Button
            data-testid="logout-button"
            variant="ghost"
            onClick={logout}
            className="w-full justify-start gap-2 text-slate-500 hover:text-rose-600"
          >
            <LogOut className="h-4 w-4" /> Esci
          </Button>
        </div>
      </aside>

      <main className="flex-1 flex flex-col min-w-0">
        <header className="sticky top-0 z-30 h-16 flex items-center px-8 border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md">
          <h1 className="font-display text-lg font-bold text-slate-900 dark:text-slate-100">
            {current?.label || "MM Operations"}
          </h1>
        </header>
        <div className="flex-1 overflow-y-auto p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
